import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'app/auth-core/auth.service';
import { BaseComponent } from 'app/common/components/base.component';
import { ModalOptions } from 'app/common/models/models';
import { ModalService } from 'app/common/services/modal.service';
import { ToastService } from 'app/common/services/toasts.service';
import { iconAdd, iconArrowBack, iconSave, iconTrash } from 'app/common/utils/icons.utils';
import { Roles, UserProfile } from 'app/models/profile.models';
import { MealPlan, Recipe } from 'app/models/recipe.model';
import { PopupInfoComponent } from 'app/pages/switch-data-analisys/popup-info/popup-info.component';
import { MealPlanService } from 'app/services/meal-plan.service';
import { ProfileService } from 'app/services/profile.service';
import { RecipeService } from 'app/services/recipe.service';
import { forkJoin } from 'rxjs';

@Component({
	selector: 'my-meal-plan-page',
	templateUrl: './my-meal-plan.page.html',
	styleUrls: ["../user-profile.page.scss", "./my-meal-plan.page.scss"]
})

export class MyMealPlanPage extends BaseComponent implements OnInit {
	pageLoaded = false;
	userProfile: UserProfile;
	mealPlans: MealPlan[] = [];
	myRecipes: Recipe[] = [];
	switchRecipes: Recipe[] = [];
	allRecipes: Recipe[] = [];
	selectedPlan: MealPlan;
	iconAdd = iconAdd;
	isAutenticated = false;
	iconArrowBack = iconArrowBack;
	iconTrash = iconTrash;
	iconSave = iconSave;
	constructor(
		protected _toastService: ToastService,
		private _translateService: TranslateService,
		private _activatedRoute: ActivatedRoute,
		private _modalService: ModalService,
		private _authService: AuthService,
		private _userProfileService: ProfileService, private _mealPlanService: MealPlanService, private _recipeService: RecipeService) {
		super();
	}

	goBack = () => {
		history.back();
	}
	isRecipeEditor = () => {
		if (this.userProfile) return this.userProfile.isInRole(Roles.RECIPE_EDITOR);
		return false;
	}
	updatePlans = () => {
		this._activatedRoute.paramMap.subscribe((params) => {
			if (params.get("planId")) {
				this._mealPlanService.getMyPlan(params.get("planId"), this.allRecipes).subscribe((res) => {					
					if (res) {
						this.selectedPlan = res;
					}
					else {
						this.selectedPlan = new MealPlan();
					}
				})
			}
			else {
				this.selectedPlan = new MealPlan();
			}
			this.pageLoaded = true;	
		})
	}

	ngOnInit() {
		this._userProfileService.loadUserProfile().subscribe((result) => {
			let call: any = {
				myRecipes: this._recipeService.getMyRecipes(),
				switchRecipes: this._recipeService.getSwitchRecipes()
			}
			forkJoin(call).subscribe((recipes) => {
				this.myRecipes = (recipes["myRecipes"] || []).sortAsc(r => r.recipeName);
				this.switchRecipes = (recipes["switchRecipes"] || []).sortAsc(r => r.recipeName);
				this.allRecipes = this.myRecipes.concat(this.switchRecipes);
				this.updatePlans();
			})
			
			this._recipeService.getMyRecipes().subscribe((recipts) => {
				this.myRecipes = (recipts || []).sortAsc(r => r.recipeName);
				this.updatePlans();
			})
			this.on(
				this._authService.isAuthenticated$.subscribe((isAutenticated) => {
					this.isAutenticated = isAutenticated;
				})
			)
			this.userProfile = result;
			
		})
	}


	get canSave() {
		return (this.selectedPlan && this.selectedPlan.planName)?true:false;
	} 
	get canRemove() {
		return (this.selectedPlan && this.selectedPlan.planName && this.selectedPlan.id)?true:false;
	}
	savePlan = () => {
		this._mealPlanService.saveOrUpdate(this.selectedPlan).subscribe((result) => {
			this.selectedPlan.id = result.id;
			this._toastService.showSuccess(this._translateService.instant("mealPlan.planSavedMessage"));

		})
	}
	removeSelected = () => {
		this._mealPlanService.delete(this.selectedPlan.id).subscribe((result) => {
			this.goBack();
		})
	}

	openSection1 = () => {
		let modalOption: ModalOptions<any> = {
			size: 'xl',
			callback: (res) => {}
		}
		let data = {
			sectionId: "mealplan-section1"
		}
		this._modalService.show(PopupInfoComponent, data, modalOption);
	}
	openSection2 = () => {
		let modalOption: ModalOptions<any> = {
			size: 'xl',
			callback: (res) => {}
		}
		let data = {
			sectionId: "mealplan-section2"
		}
		this._modalService.show(PopupInfoComponent, data, modalOption);
	}
}